import { ref } from '@nuxtjs/composition-api';
import { useVSFContext } from '@vue-storefront/core';

import getVehiclesByVIN from './getVehiclesByVIN';
import { computed } from '@nuxtjs/composition-api';
import {
  UseVINSearchError,
  UseVINSearchLoading,
  UseVINSearchResult,
} from '@composables/src/useVINSearch/types';

const useVINSearch = () => {
  const context = useVSFContext();
  const loading = ref(false);
  const result = ref(null);
  const error = ref(null);

  const refs = {
    loading,
    result,
    error,
  };

  return {
    getVehiclesByVIN: getVehiclesByVIN(context, refs),
    result: computed<UseVINSearchResult>(() => result.value),
    loading: computed<UseVINSearchLoading>(() => loading.value),
    error: computed<UseVINSearchError>(() => error.value),
  };
};

export default useVINSearch;
